import React, { useState } from 'react';
import styles from './HelpPopup.module.css';

const HelpPopup = ({ isTikTokLoggedIn = false, isSpotifyLoggedIn = false, TiktokLogOut, videoUrl, buttonLabel = "?", popupTitle = "Need Help?", popupMessage = "Watch the video below for guidance:", buttonText = "Remove TikTok Account" }) => {
  const [showHelp, setShowHelp] = useState(false);

  const handleToggleHelp = () => {
    setShowHelp((prev) => !prev);
  };

  return (
    <>
      {/* Sticky Circular Help Button */}
      <button onClick={handleToggleHelp} className={styles["help-button"]}>
        {buttonLabel}
      </button>

      {/* Help Popup */}
      {showHelp && (
        <div className={styles["popup-overlay"]}>
          <div className={styles["popup"]}>
            <button onClick={handleToggleHelp} className={styles["close-button"]}>
              ×
            </button>
            <h2>{popupTitle}</h2>
            <p>{popupMessage}</p>
            <div className={styles["video-container"]}>
              <iframe
                width="100%"
                height="100%"
                src={videoUrl} // Dynamic video URL
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          

            <div className={styles.box} style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
              {isTikTokLoggedIn || isSpotifyLoggedIn  ? (
                <button id="SignOutButton" type="button" className={styles.button} onClick={TiktokLogOut}>
                  {buttonText}
                </button>
              ) : null }
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpPopup;
